/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchUserUnlocodeSelectionsRequestActionCreator } from '../../../user/redux/actions/UserActions';
import { departureUnlocodeCheckedActionCreator } from '../../../wizard/target-node-unlocode-selector/redux/actions/DeparturePostalOperatorActions';
import { arrivalUnlocodeCheckedActionCreator } from '../../../wizard/target-node-unlocode-selector/redux/actions/ArrivalPostalOperatorActions';
import {
  saveGlobalSelectionUnlocodeRequestActionCreator,
  deleteGlobalSelectionUnlocodeRequestActionCreator, setTabButtonStatus,
} from '../redux/actions/AdminDashboardActions';
import OperatorTypes from '../../../common/redux/actions/types/OperatorTypes';
import Icons from '../../../../core/modules/common/components/Icons';
import DeleteModal from '../../../common/components/DeleteModal';
import { createPresetSelections } from '../../../react-table/helpers/utils';
import SaveSelectionModal from '../components/SaveSelectionModal';
import Button from '../../../../core/modules/common/components/Button';
import EditUnlocodeSelectionModal from '../../../wizard/target-node-unlocode-selector/components/EditUnlocodeSelectionModal';
import WarningModal from '../../../common/components/WarningModal';

function operatorSelectorSelector(props, state) {
  switch (props.operatorType) {
    case OperatorTypes.DEPARTURE:
      return state.postalOperatorUnlocodeSelector.departure;
    case OperatorTypes.ARRIVAL:
      return state.postalOperatorUnlocodeSelector.arrival;
    default:
      return state.postalOperatorUnlocodeSelector.departure;
  }
}

const mapStateToProps = (state, props) => ({
  selections: operatorSelectorSelector(props, state).selections,
});

class AdminPresetLocationSidebarContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      DEPARTURE: { activeSelection: 'Your last selection' },
      ARRIVAL: { activeSelection: 'Your last selection' },
      newSelection: '',
      newPresetButtonDisabled: false,
      checkedUnlocodes: [],
      name: '',
      showDeleteSelectionModal: false,
      showEditSelectionModal: false,
      showSaveSelectionModal: false,
      showOverwriteNewSelectionModal: false,
      showOverwriteSelectionModal: false,
      saveSelectionCheckedUnlocodes: [],
      saveSelectionSelections: [],
      nameUi: '',
    };
  }

  componentDidMount() {
    const {
      operatorType,
    } = this.props;
    this.props.fetchUserUnlocodeSelectionsRequestActionCreator(operatorType);
  }

  componentDidUpdate(prevProps) {
    const { selections } = this.props;
    if (selections !== prevProps.selections) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        newSelection: selections,
      });
    }
  }

  onCloseModal = () => {
    this.setState({
      showDeleteSelectionModal: false,
    });
  };

  // eslint-disable-next-line react/sort-comp
  applySelection = (e, selection) => {
    const reportDef = {
      locationType: 'IMPC',
    };
    if (this.props.operatorType === OperatorTypes.DEPARTURE) {
      this.props
        .departureUnlocodeCheckedActionCreator(
          createPresetSelections(selection.unlocodes, this.props.operators),
          reportDef,
        );
    } else if (this.props.operatorType === OperatorTypes.ARRIVAL) {
      this.props
        .arrivalUnlocodeCheckedActionCreator(
          createPresetSelections(selection.unlocodes, this.props.operators),
          reportDef,
        );
    }
    this.setState({
      [this.props.operatorType]: { activeSelection: selection.name },
    });
  };

  openDeleteSelectionModal = (e, selection) => {
    this.setState({
      showDeleteSelectionModal: true,
      nameUi: selection.name,
    });
  };

  deleteSelection = () => {
    this.props.deleteGlobalSelectionUnlocodeRequestActionCreator(this.state.nameUi);
    this.onCloseModal();
  };

  openEditSelectionModal = (e, selection) => {
    e.stopPropagation();
    this.setState({
      showEditSelectionModal: true,
      saveSelectionCheckedUnlocodes: this.props.checked,
      saveSelectionSelections: this.props.selections,
      nameUi: selection.name,
    });
  };

  editSelection = ({ name, checkedUnlocodes }) => {
    this.setState({
      name,
      checkedUnlocodes,
    });
    if (name && name !== this.state.nameUi) {
      this.setState({
        showOverwriteNewSelectionModal: true,
        showOverwriteSelectionModal: false,
      });
    } else {
      this.setState({
        showOverwriteNewSelectionModal: false,
        showOverwriteSelectionModal: true,
      });
    }
    this.setState({
      newPresetButtonDisabled: false,
    });
    this.closeEditSelectionModal();
  };

  overwriteNewSelection = () => {
    this.props.saveGlobalSelectionUnlocodeRequestActionCreator(this.state.name, 'I', this.props.operatorType, this.state.checkedUnlocodes);
    this.props.setTabButtonStatus(false);
    this.onCloseNewOverwriteModal();
  };

  overwriteSelection = () => {
    this.props.saveGlobalSelectionUnlocodeRequestActionCreator(this.state.nameUi, 'I', this.props.operatorType, this.state.checkedUnlocodes);
    this.props.setTabButtonStatus(false);
    this.onCloseOverwriteModal();
  };

  closeEditSelectionModal = () => {
    this.setState({
      showEditSelectionModal: false,
    });
  };

  onCloseOverwriteModal = () => {
    this.setState({
      showOverwriteSelectionModal: false,
    });
  };

  onCloseNewOverwriteModal = () => {
    this.setState({
      showOverwriteNewSelectionModal: false,
    });
  };

  openSaveSelectionModal = () => {
    this.setState({
      showSaveSelectionModal: true,
    });
  };

  closeSaveSelectionModal = () => {
    this.setState({
      showSaveSelectionModal: false,
    });
  };

  saveSelection = ({ name }) => {
    const newPreset = [...this.props.selections];
    newPreset.unshift({
      name, scope: 'GLOBAL', direction: 'I', unlocodes: [],
    });
    this.setState({
      newSelection: newPreset,
      newPresetButtonDisabled: true,
    });
    this.closeSaveSelectionModal();
  };

  render() {
    const {
      operatorType,
    } = this.props;
    const {
      newSelection,
      newPresetButtonDisabled,
      showDeleteSelectionModal,
      showEditSelectionModal,
      showSaveSelectionModal,
      showOverwriteNewSelectionModal,
      showOverwriteSelectionModal,
      saveSelectionCheckedUnlocodes,
      saveSelectionSelections,
    } = this.state;
    return (
      <div className="operator-sidebar-div">
        <div className="selection-title">
          <FormattedMessage
            tagName="h5"
            id="app.selection.admin.list.location.title.label"
            values={{ operatorType }}
          />
          <Button
            className="sidebar-new-preset-button"
            text="app.selection.new.preset"
            onClick={() => this.openSaveSelectionModal()}
            disabled={newPresetButtonDisabled}
          />
        </div>
        {newSelection && newSelection.length > 0 ? (
          <div className="user-selections">
            {showDeleteSelectionModal &&
              <DeleteModal
                headerFormattedMessageId="app.warning.delete.save.operator.selection"
                onCloseModal={this.onCloseModal}
                deleteSelection={this.deleteSelection}
              />
              }
            {showOverwriteSelectionModal &&
              <WarningModal
                headerFormattedMessageId="app.warning.save.overwrite.operator.selection"
                onCloseModal={this.onCloseOverwriteModal}
                deleteSelection={this.overwriteSelection}
              />
              }
            {showOverwriteNewSelectionModal &&
              <WarningModal
                headerFormattedMessageId="app.warning.save.new.overwrite.operator.selection"
                onCloseModal={this.onCloseNewOverwriteModal}
                deleteSelection={this.overwriteNewSelection}
              />
              }
            {showEditSelectionModal &&
              <EditUnlocodeSelectionModal
                saveSelection={this.editSelection}
                closeModal={this.closeEditSelectionModal}
                checkedUnlocodes={saveSelectionCheckedUnlocodes}
                selections={saveSelectionSelections}
                name={this.state.nameUi}
              />
              }
            {showSaveSelectionModal &&
              <SaveSelectionModal
                saveSelection={this.saveSelection}
                closeModal={this.closeSaveSelectionModal}
                selections={this.props.selections}
                title="app.save.empty.new.preset"
              />
              }
            <ul className="global-ul">
              { newSelection
                  .filter(selection => selection.scope === 'GLOBAL' && selection.name !== 'Your last selection')
                  .map(selection => (
                    <li
                      key={selection.name}
                      onClick={e => this.applySelection(e, selection)}
                      className={this.state[operatorType].activeSelection === selection.name ? 'active' : ''}
                    >
                      <button
                        className="global-icon"
                        key={selection.name}
                        onClick={e => this.openDeleteSelectionModal(e, selection)}
                      >
                        <Icons.Custom name="trash-o" />
                      </button>
                      <button
                        className="global-icon-edit"
                        onClick={e => this.openEditSelectionModal(e, selection)}
                      >
                        <Icons.Custom name="save" />
                      </button>
                      {selection.name}
                    </li>
                  )) }
            </ul>
          </div>
          ) :
          <FormattedMessage id="app.selection.list.empty" />
        }
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({
  fetchUserUnlocodeSelectionsRequestActionCreator,
  deleteGlobalSelectionUnlocodeRequestActionCreator,
  departureUnlocodeCheckedActionCreator,
  arrivalUnlocodeCheckedActionCreator,
  saveGlobalSelectionUnlocodeRequestActionCreator,
  setTabButtonStatus,
}, dispatch);

AdminPresetLocationSidebarContainer.propTypes = {
  selections: PropTypes.arrayOf(PropTypes.shape({
    scope: PropTypes.string,
    name: PropTypes.string.isRequired,
    unlocodes: PropTypes.arrayOf(PropTypes.string).isRequired,
  })),
  fetchUserUnlocodeSelectionsRequestActionCreator: PropTypes.func,
  deleteGlobalSelectionUnlocodeRequestActionCreator: PropTypes.func,
  saveGlobalSelectionUnlocodeRequestActionCreator: PropTypes.func,
  departureUnlocodeCheckedActionCreator: PropTypes.func,
  arrivalUnlocodeCheckedActionCreator: PropTypes.func,
  operatorType: PropTypes.string,
  operators: PropTypes.arrayOf(PropTypes.object),
  checked: PropTypes.arrayOf(PropTypes.string),
  setTabButtonStatus: PropTypes.func,
};

export const ConnectedAdminPresetLocationSidebarContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(AdminPresetLocationSidebarContainer);

export default (ConnectedAdminPresetLocationSidebarContainer);

